export default __webpack_public_path__ + "static/media/fadeelah.e3d8839b.png";